import { type LineCustomSvgLayer } from '@nivo/line'
import { type LineChartSeries } from './types'

// We lose the animation of the lines when using this custom line. We could re-implement it if needed
export const LineChartCustomLine: LineCustomSvgLayer<LineChartSeries> = ({ series, lineGenerator }) => {
    return series.map((serie) => {
        return (
            <path
                key={serie.id}
                style={{ strokeDasharray: serie.dashedLine ? '8 4' : 'initial', fill: 'none' }}
                d={
                    lineGenerator(serie.data.filter((d) => !d.data.isPrediction).map((d) => ({ x: d.position.x, y: d.position.y }))) ||
                    undefined
                }
                stroke={serie.color}
            />
        )
    })
}
